// extracted by mini-css-extract-plugin
module.exports = {"main":"_36UxN","downloadBtn":"_343cd"};